import React, { useEffect, useRef, useState } from "react";
import "../../assets/styles/auth/auth.css";
import Icon from "../../components/ui/icon";
import { useToast } from "../../context/toastContext";
import axios from "axios";
import DOMPurify from "dompurify";
import HorizontalLogo from '../../assets/logos/horizontal-logo.png';
import { NavLink, useParams } from "react-router-dom";

const RegisterPage = () => {
  const [isTCChecked, setisTCChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [name, setName] = useState("");
  const [isRegBtnD, setIsRegBtnD] = useState(false);
  const [emailID, setEmailID] = useState("");
  const [password, setPassword] = useState("");
  const [contactPlatform, setContactPlatform] = useState("");
  const [contactUsername, setContactUsername] = useState("");
  const [trafficSource, setTrafficSource] = useState("");
  const showToast = useToast();
  let { mAdminId } = useParams();
  let ManagerAdminId = DOMPurify.sanitize(mAdminId);
  const mangerIdInLocal = DOMPurify.sanitize(localStorage.getItem("ManagerAdminId"));
  const [open, setOpen] = useState(false);
  const selectorRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        selectorRef.current &&
        !selectorRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    window.addEventListener("mousedown", handleClickOutside);
    return () =>
      window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!ManagerAdminId) {
    if (mangerIdInLocal) {
      ManagerAdminId = mangerIdInLocal;
    }
  } else {
    localStorage.setItem("ManagerAdminId", ManagerAdminId)
  }

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const handelRegBtn = () => {
    if (isRegBtnD) return;
    setIsRegBtnD(true);

    const sanitizedName = sanitizeInput(name);
    const sanitizedNumber = sanitizeInput(mobileNumber);
    const sanitizedEmail = sanitizeInput(emailID);
    const sanitizedPaswword = sanitizeInput(password);
    const sanitizedPlatform = sanitizeInput(contactPlatform);
    const sanitizedContactUsername = sanitizeInput(contactUsername);
    const sanitizedTrafficSource = sanitizeInput(trafficSource);

    if (sanitizedName.length <= 3) {
      document.getElementById("name").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (sanitizedNumber.length <= 0) {
      document.getElementById("mobNumber").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (sanitizedEmail.length <= 0) {
      document.getElementById("emailID").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (sanitizedPaswword.length <= 0) {
      document.getElementById("password").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (!sanitizedPlatform) {
      document.getElementById("contact_platform").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (
      sanitizedPlatform !== "Telegram" &&
      sanitizedPlatform !== "Microsoft Teams"
    ) {
      document.getElementById("contact_platform").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (sanitizedContactUsername.length < 3) {
      document.getElementById("contact_username").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (sanitizedPlatform === "Telegram") {
      const telegramRegex = /^(?!\d)[a-zA-Z0-9_]{5,32}$/;
      if (!telegramRegex.test(sanitizedContactUsername)) {
        document.getElementById("contact_username").focus();
        navigator.vibrate([200]);
        setIsRegBtnD(false);
        return;
      }
    }

    if (sanitizedPlatform === "Microsoft Teams") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(sanitizedContactUsername)) {
        document.getElementById("contact_username").focus();
        navigator.vibrate([200]);
        setIsRegBtnD(false);
        return;
      }
    }

    if (sanitizedTrafficSource.length < 6) {
      document.getElementById("trafficSource").focus();
      navigator.vibrate([200]);
      setIsRegBtnD(false);
      return;
    }

    if (!isTCChecked) {
      showToast({
        status: "error",
        message: "Accept Our Conditions.",
      });
      setIsRegBtnD(false);
      return;
    }

    axios
      .post(`${window.location.origin === 'http://localhost:3000' ? 'http://localhost:5500' : window.location.origin}/api/auth/register`, {
        name: sanitizedName,
        phone: sanitizedNumber,
        email: sanitizedEmail,
        password: String(sanitizedPaswword),
        ManagerAdminId,
        contactPlatform: sanitizedPlatform,
        contactUsername: sanitizedContactUsername,
        trafficSource: sanitizedTrafficSource
      })
      .then((response) => {
        if (response.data.status) {
          showToast({
            status: "success",
            message: response.data?.message || "Account Created Successfully.",
          });
        } else {
          showToast({
            status: "error",
            message: response.data?.message || "Acc Creation Failed.",
          });
        }
      })
      .catch((error) => {
        showToast({
          status: "error",
          message: error.response?.data?.message || "Something went wrong.",
        });
      })
      .finally(() => {
        setIsRegBtnD(false);
      });
  };

  return (
    <div className="login__page register__page">
      <div className="company-info">
        <img src={HorizontalLogo} alt="Company Logo" />
        <h1>Swift Digital Ads</h1>
        <p>
          Someone who not just help you grow but also help you track your growth
        </p>
      </div>

      <div className="main-content">
        <h1>Join Us Today!</h1>
        <p>
          Enter basic details about you to create your account and start
          growing.
        </p>

        <div className="login-form">
          <div className="inp-box">
            <label htmlFor="name">Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              id="name"
              placeholder="eg: jhon doe"
              autoComplete="off"
            />
          </div>

          <div className="inp-box">
            <label htmlFor="emailID">Email ID</label>
            <input
              value={emailID}
              onChange={(e) => setEmailID(e.target.value)}
              type="email"
              id="emailID"
              placeholder="eg: jhon@gmail.com"
              autoComplete="off"
            />
          </div>

          <div className="inp-box">
            <label htmlFor="mobNumber">Mobile Number</label>
            <input
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              type="number"
              id="mobNumber"
              placeholder="eg: 9999999999"
              autoComplete="off"
            />
          </div>

          <div className="inp-box">
            <label htmlFor="password">Password</label>
            <div className="inp-with-btn">
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="*********"
                autoComplete="off"
              />
              <button onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <Icon name="EyeSlash" /> : <Icon name="Eye" />}
              </button>
            </div>
          </div>

          <div className="inp-box-container">
            <div className="inp-box selector" ref={selectorRef}>
              <label htmlFor="contact_platform">Social Media Platform</label>
              <input
                value={contactPlatform}
                type="text"
                id="contact_platform"
                placeholder="eg: Telegram"
                readOnly
                onClick={() => setOpen(!open)}
              />

              {open && (
                <div className="selector-dropdown">
                  <div
                    className="selector-item"
                    onClick={() => {
                      setContactPlatform("Telegram");
                      setOpen(false);
                    }}
                  >
                    Telegram
                  </div>
                  <div
                    className="selector-item"
                    onClick={() => {
                      setContactPlatform("Microsoft Teams");
                      setOpen(false);
                    }}
                  >
                    Microsoft Teams
                  </div>
                </div>
              )}
            </div>

            <div className="inp-box">
              <label htmlFor="contact_username">
                {contactPlatform
                  ? `${contactPlatform} Username`
                  : "Social Media Username"}
              </label>

              <input
                id="contact_username"
                type="text"
                value={contactUsername}
                onChange={(e) => setContactUsername(e.target.value)}
                placeholder={
                  contactPlatform === "Telegram"
                    ? "eg: telegram_username"
                    : contactPlatform === "Microsoft Teams"
                      ? "eg: user@company.com"
                      : "Select platform first"
                }
                autoComplete="off"
                disabled={!contactPlatform}
              />
            </div>
          </div>

          <div className="inp-box">
            <label htmlFor="trafficSource">Traffic Source</label>
            <input
              value={trafficSource}
              onChange={(e) => setTrafficSource(e.target.value)}
              type="text"
              id="trafficSource"
              placeholder="eg: Telegram and youtube"
              autoComplete="off"
            />
          </div>
        </div>

        <div className="tc-sec">
          <div
            onClick={() => setisTCChecked(!isTCChecked)}
            className={`tc-box ${isTCChecked ? "checked" : ""}`}
          >
            {isTCChecked && <Icon name="Check" />}
          </div>
          <p>I accept <a href="https://swiftdigitalads.com/doc/terms" target="_blank" rel="noreferrer">terms & conditions</a> and <a href="https://swiftdigitalads.com/doc/privacy" target="_blank" rel="noreferrer">privacy policy</a>.</p>
        </div>

        <button
          className="login-btn"
          onClick={handelRegBtn}
          disabled={isRegBtnD}
        >
          {isRegBtnD ? (
            <>
              Checking... <Icon name="ArrowPath" className="icon-spin" />
            </>
          ) : (
            <>
              Sign UP <Icon name="ChevronRight" />
            </>
          )}
        </button>

        <div className="divider">
          <div className="line"></div>
          <p className="text">Quick Links</p>
        </div>

        <div className="QuickLinks">
          <NavLink to="/auth/forget-password">Forget Password?</NavLink>
          <NavLink to="/auth/login">Login</NavLink>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
